export class Store {
  chainID: string;
  hoID: string;
  storeID: string;
  display: string;
}
